<template>
	<div class="pastorderwin">
		<el-dialog :visible.sync="showpastorderwin&&searchItem.length>0" width="500px" :close-on-click-modal="false"
		 lock-scroll :modal-append-to-body="false" :show-close="false" :destroy-on-close="true" >
			<div style="height:430px" align="center">
				<table class="htmltable">
					<tr v-for="(item,index) in searchItem" :key="index">
						<td><label>{{item.label}}</label></td>
						<td>
							<el-input v-if="item.coltype=='textarea'" type="textarea" rows="3" v-model="item.value" size="mini" :placeholder="item.placeholder"></el-input>
							<el-input v-if="item.coltype=='text'" type="text" v-model="item.value" size="mini" :placeholder="item.placeholder"></el-input>
							<el-date-picker v-if="item.coltype=='date'"
								v-model="item.value"
								type="date"
								:placeholder="item.placeholder"
								size="mini"
								value-format="yyyy-MM-dd"
							></el-date-picker>
							<el-date-picker v-if="item.coltype=='datetime_mm'"
								v-model="item.value"
								type="datetime"
								:placeholder="item.placeholder"
								size="mini"
								format="yyyy-MM-dd HH:mm"
								@change="val=>formatdate(val,'datetime_mm',item)"
							></el-date-picker>
							<el-select v-if="item.coltype=='select'" v-model="item.value" filterable size="mini"  :placeholder="item.placeholder" clearable>
							    <el-option
							      v-for="it in item.colsource"
							      :key="it.value"
							      :label="it.label"
							      :value="it.value" 
								  >
							    </el-option>
							</el-select>
							<el-autocomplete
								:ref="item.colname"
								v-if="item.coltype == 'input_filter'"
								clearable 
								:placeholder="item.placeholder"
								v-model="item.value"
								:fetch-suggestions="
									(queryString, cb) => {
										inputsuggestions(queryString, cb, item);
									}
								"
								value-key="showname"
								size="mini"
								:trigger-on-focus="true"
							></el-autocomplete>
						</td>
					</tr>
					<tr style="height:80px;">
						<td colspan="2" style="width:310px;text-align:center">
							<el-button type="success" size="mini" @click="nextstep">{{$lang.label.public.nextstep}}</el-button>
							<el-button size="mini" @click="showpastorderwin = false">{{$lang.label.public.cancel}}</el-button>
						</td>
					</tr>
				</table>
			</div>
		</el-dialog>
		<exportwin ref="exportwinnew"></exportwin>
	</div>
</template>
<script>
import exportwin from '@/components/tools/exportwin_new.vue';	
export default {
	components: {
		exportwin
	},
	data() {
		return {
			orderids: '',
			checkedbatch: '',
			showpastorderwin: false, //是否显示
			l_mode: '',
			fun: '',
			btndisabled:true,
			l_id:'',
			searchItem:[],
			
			// {label:'结算单位',coltype:'input_filter',name:'V_huodai_dd_feelist',colevent:'getcrmlist',collink:'=',value:'',colname:'结算单位'},
			// {label:'航班日期起',coltype:'date',name:'V_huodai_dd',colevent:'',collink:'>=',value:'',colname:'航班日期'},
			// {label:'航班日期止',coltype:'date',name:'V_huodai_dd',colevent:'',collink:'<=',value:'',colname:'航班日期'}
			
			handtype:'',
			exportwin_lang:{}
		};
	},
	mounted() {},
	methods: {
		init(param) {
			var that=this;
			that.searchItem=[];
			this.l_mode = param.l_mode;
			this.showpastorderwin = true;
			this.fun = param.fun;
			this.l_id=param.l_id;
			this.handtype=param.handtype;
			this.$public.GetLanguageByMode('exportwin',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.exportwin_lang=that.$lang.label.exportwin;
					that.getSearchItem();
				}
			});
		},
		//获取筛选条件配置
		getSearchItem(){
			var that=this;
			//debugger
			this.$apipost.get.GetFilterSet({l_id:this.l_id,type:'导出筛选'}).then(res => {
				//debugger
				if(res.state=='1'){
					res.list.forEach(e=>{
						if(that.exportwin_lang[e.label]!=undefined)
							e.label=that.exportwin_lang[e.label];
						if(e.placeholder!=undefined&&e.placeholder!='')
							e.placeholder=that.exportwin_lang[e.placeholder];
						e.value='';	
					});
					that.searchItem=res.list;
				}
			}).catch(e=>{
				
			});
		},
		nextstep() {
			this.btndisabled=true;
			for(var i=0;i<this.searchItem.length;i++){
				if(this.searchItem[i].value!='')
				{
					isgo=true;
					break;
				}	
			}
			var isgo=true;
			if(isgo){
				var list=[];
				this.searchItem.forEach(e=>{
					list.push({"colname":e.colname,"coltype":e.coltype,"name":e.name,"value":e.value,"collink":e.collink});
				});
				//检测筛选条件是否必填
				this.showpastorderwin = false;
				//组合筛选条件，并插入到临时表
				this.$refs.exportwinnew.init({
					handtype:this.handtype,
					searchItem:list
				});
			}
		},
		formatdate(val,type,item){
			//debugger
			if(type=='datetime_mm'){
				item.value=this.$tool.datetotime(val);
			}
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i) {
			//console.log(i);
			var that=this;
			if(i.colevent=='getcrmlist'){
				if(i.value!=''){
					//setTimeout(function(){
						that.$tool.crmlist_call(that, i, cb);
					//},1000);
				}
				else
					this.$tool.crmlist_call(this, i, cb);
			}
		}
	}
};
</script>

<style></style>
